import { IInitialState } from 'store/models';
import { moduleStateSelector } from 'modules/admin-panel/selectors';

export function clientsStateSelector(state: IInitialState) {
	return moduleStateSelector(state).clients;
}
